
import React from 'react';
import { useTheme } from 'next-themes';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Moon, Sun, Palette, Droplets, CircleDot, Sparkles, Flame, Zap, Heart, Crown, Monitor } from 'lucide-react';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9 rounded-full text-white">
          {theme === 'dark' ? <Moon className="h-4 w-4" /> : 
           theme === 'light' ? <Sun className="h-4 w-4" /> : 
           theme === 'system' ? <Monitor className="h-4 w-4" /> :
           <Palette className="h-4 w-4" />}
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme('system')}>
          <Monitor className="mr-2 h-4 w-4" />
          <span>System</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('light')}>
          <Sun className="mr-2 h-4 w-4" />
          <span>Light</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          <Moon className="mr-2 h-4 w-4" />
          <span>Dark</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('teal')}>
          <Droplets className="mr-2 h-4 w-4 text-nalc-teal" />
          <span>Teal</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('purple')}>
          <CircleDot className="mr-2 h-4 w-4 text-purple-500" />
          <span>Purple</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('blue')}>
          <CircleDot className="mr-2 h-4 w-4 text-blue-500" />
          <span>Blue</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('orange')}>
          <CircleDot className="mr-2 h-4 w-4 text-orange-500" />
          <span>Orange</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('cosmic')}>
          <Sparkles className="mr-2 h-4 w-4 text-indigo-500" />
          <span>Cosmic</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('sunset')}>
          <Flame className="mr-2 h-4 w-4 text-pink-500" />
          <span>Sunset</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('electric')}>
          <Zap className="mr-2 h-4 w-4 text-cyan-400" />
          <span>Electric</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('rose')}>
          <Heart className="mr-2 h-4 w-4 text-rose-500" />
          <span>Rose Gold</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('royal')}>
          <Crown className="mr-2 h-4 w-4 text-amber-500" />
          <span>Royal</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
